import { CurrencyModel } from './currency.model';

export class FixingModel {
  public id = -1;
  public dateFixing: any = null;
  public currency: CurrencyModel;
  public rate = 0;
  public codeCurrencyRef: string;

  constructor() {}

  public fromJSON(json) {
    for (const propName in json) {
      if (json.hasOwnProperty(propName)) {
        this[propName] = json[propName];
        return this;
      }
    }
  }
}
